import React, { useEffect, useState } from "react";
import FormSectionLayout from "../../layouts/FormSectionLayout";
import HeadingText from "../../common/HeadingText/HeadingText";
import { Container, Form, Row, Col } from "reactstrap";
import "./PlanAssignmentPage.scss";
import ButtonComponent from "../../common/Button/ButtonComponent";
import LoaderComponent from "../../common/Loader/Loader";
import TextField from "../../common/TextField/TextField";
import Toaster from "../../common/Toaster/Toaster";
import {
  IPlanAssignmentPageProps,
  IPlanAssignmentPageState,
} from "../../../interfaces/Index";
import { Can } from "../../../config/Can";

const PlanAssignmentPage: React.FunctionComponent<IPlanAssignmentPageProps> = (
  props
) => {
  const headingText = "Plan selection";

  const buttonText = "Save";

  const [planState, setPlanState] = useState<IPlanAssignmentPageState>({
    plans: props.dummyPlans || "",
  });

  const [showToaster, setToaster] = useState({
    isVisible: false,
    message: "",
    isError: false,
  });

  useEffect(() => {
    const { isPlanAssigned } = props;
    if (isPlanAssigned) {
      const message = "Plan assigned successfully!";
      handleToaster(false, message);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
  }, [props.isPlanAssigned]);

  useEffect(() => {
    const { error, isError } = props;
    if (isError) {
      alert((error! as any).errors);
    }
  }, [props.isError]);

  const validateForm = !!planState.plans;

  const handleToaster = (error: boolean, message: string) => {
    setToaster({
      isVisible: true,
      message: message,
      isError: error,
    });
  };

  const handleChange = (e: any) => {
    setPlanState({
      plans: e.target.value,
    });
  };

  const handleSubmit = () => {
    const { assignPlan } = props;
    assignPlan(planState.plans.split(",").map((item) => item.trim()));
  };

  const renderPlanDetail = () => {
    return (
      <FormSectionLayout subTitleText="Assignment">
        <TextField
          id="plans"
          label="Plan list"
          placeholder="Enter plans as comma seperated list"
          type="textarea"
          handleChange={handleChange}
        />
        {renderFormButton()}
      </FormSectionLayout>
    );
  };

  const renderFormButton = () => {
    return (
      <div className="form-row-separator">
        <Row id="addEditButtonRow" className="add-update-button-container">
          <Col lg="6">
            <Can I="update" a="plan">
              <ButtonComponent
                buttonClass="large-button btn-primary"
                buttonText={buttonText}
                onClickHandler={handleSubmit}
                isDisable={props.isLoading || !validateForm}
              />
            </Can>
          </Col>
        </Row>
      </div>
    );
  };

  return (
    <Container fluid>
      {props.isLoading && <LoaderComponent />}
      <Toaster
        showToaster={showToaster.isVisible}
        toasterClass={
          showToaster.isError
            ? "toaster toaster-bg-danger"
            : "toaster toaster-bg-success"
        }
      >
        {showToaster.message || ""}
      </Toaster>
      <Row className="plan-assignment-heading">
        <Col lg="5">
          <HeadingText text={headingText} isMainHeading={true} />
        </Col>
      </Row>
      <Row className="form-container">
        <Col xs="12">
          <Form>
            <div className="tour-details">{renderPlanDetail()}</div>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default PlanAssignmentPage;
